import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculator-form.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
var CalculatorForm = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorForm, _super);
    function CalculatorForm(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.timeout = null;
        _this.formValid = true;
        return _this;
    }
    CalculatorForm.prototype.init = function () {
        this.inputs = Array.from(this.element.querySelectorAll('input'));
        this.modifiers = Array.from(this.element.querySelectorAll('.js-calculator-modifier'));
        this.modifierToggles = Array.from(this.element.querySelectorAll('.js-calculator-modifier-toggle'));
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-calculator-radio-group'));
        this.addonToggles = Array.from(this.element.querySelectorAll('.js-calculator-addon-toggle'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-calculate'));
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
        this.calculator = this.element.querySelector('form');
        this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));
        this.modalLinks = Array.from(this.element.querySelectorAll('.js-calculator-modal'));
        this.termChecker = Array.from(this.element.querySelectorAll("select[name=term]"));
        TooltipsService.initTooltips();
    };
    CalculatorForm.prototype.bindEvents = function () {
        var _this = this;
        this.calculatorSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            // animate back to top
            if ($(window).width() > 480) {
                $('html,body').animate({
                    scrollTop: $('div.calculators').offset().top - 10
                }, 'slow');
            }
            var allFields = _this.calculator.querySelectorAll('input');
            if (_this.formValid) {
                _this.calculatorService.detect(_this.calculator);
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmFormComplete("complete", "");
            }
        }); });
        this.modifiersRadiosToggle.map(function (item) { return item.addEventListener('click', function (event) {
            var targetField = event.target;
            var visibleGroups = Array.from(_this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
            var radioContainers = Array.from(_this.element.querySelectorAll('.js-calculator-radio-group-containers'));
            radioContainers.map(function (item) {
                item.classList.add('calculator-form__hidden');
                var inputs = Array.from(item.querySelectorAll('input'));
                inputs.map(function (item) {
                    var getDefaultValue = item.value;
                    if (!getDefaultValue == undefined || getDefaultValue == '') {
                        item.value = '';
                    }
                    else {
                        item.value = getDefaultValue;
                    }
                });
            });
            visibleGroups.map(function (item) {
                item.classList.remove('calculator-form__hidden');
            });
        }); });
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            _this.resetInputs(event);
        }); });
        this.modifierToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleModifiers(event);
        }); });
        this.addonToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleAddons(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('input', function (event) {
            _this.copyField(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('change', function (event) {
            _this.copyField(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModal(event);
        }); });
        // INPUTS
        this.inputs.map(function (item) { return item.addEventListener('focusin', function (event) {
            _this.onFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('focusout', function (event) {
            _this.outFocusInput(event);
            _this.validationService.validateCalculator(event, _this.calculatorSubmit);
            var _valid = Array.from(_this.element.querySelectorAll('.calculator-form__error'));
            if (_valid.length > 0) {
                _this.formValid = false;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.add('button--disabled');
                });
            }
            else {
                _this.formValid = true;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.remove('button--disabled');
                });
            }
        }); });
        this.inputs.map(function (item) { return item.addEventListener('keyup', function (event) {
            _this.keyInput(event);
        }); });
        if (this.termChecker) {
            this.termChecker.map(function (item) { return item.addEventListener('change', function (event) {
                _this.checkBaloonPayments(event);
            }); });
        }
    };
    CalculatorForm.prototype.openModal = function (event) {
        var modalId = event.currentTarget.parentNode.getAttribute('data-modal');
        this.event.emit('openModal', {
            id: modalId
        });
    };
    CalculatorForm.prototype.copyField = function (event) {
        var fieldParentContainer = this.findFieldCopy(event.target.parentNode);
        var copyValue = Number.parseFloat(event.target.value);
        var _tmpValue = String(event.target.value).split('.');
        if (_tmpValue.length > 1) {
            if (_tmpValue[1].length > 2) {
                copyValue = Number.parseFloat(event.target.value).toFixed(2);
            }
        }
        var fieldName = fieldParentContainer.getAttribute('data-target');
        var fields = fieldParentContainer.querySelectorAll(".js-" + fieldName);
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].classList.contains('js-not-zero')) {
                if (copyValue == 0) {
                    copyValue = 1;
                }
            }
            fields[i].value = copyValue;
        }
        // Form form start (if not started yet) when slider is being interacted with
        this.analyticsService.dtmTriggerFormStart(fields[0]);
    };
    CalculatorForm.prototype.findFieldCopy = function (parent) {
        while ((parent = parent.parentElement) && !parent.classList.contains('js-copy-fields'))
            ;
        return parent;
    };
    CalculatorForm.prototype.toggleModifiers = function (event) {
        event.preventDefault();
        var targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetModifier = this.element.querySelector("#" + targetModifierId);
        if (targetModifier.classList.contains('calculator-form__modifiers--open')) {
            targetModifier.classList.remove('calculator-form__modifiers--open');
            event.currentTarget.classList.add('calculator-form__link--open');
        }
        else {
            targetModifier.classList.add('calculator-form__modifiers--open');
            event.currentTarget.classList.remove('calculator-form__link--open');
        }
    };
    CalculatorForm.prototype.toggleAddons = function (event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('link--disabled')) {
            return;
        }
        var targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetAddon = this.element.querySelector('#' + targetAddonId);
        var targetInput = targetAddon.querySelector("input");
        var _tmpText = event.currentTarget.querySelector(".link__text");
        var _coAppText = this.element.querySelector(".co_app_text");
        if (targetAddon.classList.contains("calculator-form__addon--open")) {
            if (targetInput) {
                targetInput.value = "0";
                targetInput.placeholder = "0";
            }
            targetAddon.classList.remove('calculator-form__addon--open');
            _tmpText.innerText = "+ Add co-applicant's income";
            if (_coAppText) {
                _coAppText.innerText = "";
            }
        }
        else {
            if (targetInput) {
                targetInput.value = "0";
                targetInput.placeholder = "0";
            }
            targetAddon.classList.add('calculator-form__addon--open');
            _tmpText.innerText = "- Remove co-applicant's income";
            if (_coAppText) {
                _coAppText.innerText = "(including co-applicant)";
            }
        }
    };
    CalculatorForm.prototype.resetInputs = function (event) {
        event.preventDefault();
        var errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
        errorLabels.map(function (item) {
            var parent = item;
            $(parent).removeClass('calculator-form__error');
            $(parent).find('div.calculator-form__error-label').remove();
        });
        this.calculator.reset();
        this.formValid = true;
        this.calculatorService.resetValues(this.calculator);
        this.inputs.map(function (item) {
            if (item.getAttribute('type') != 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    CalculatorForm.prototype.onFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        var value = field.value;
        var newValue = value.replace(/ /g, '');
        var _value = parseFloat(newValue);
        var min = parseFloat(field.getAttribute('min'));
        var max = parseFloat(field.getAttribute('max'));
        if (min && max) {
            if ((_value < min) && (_value > max)) {
                field.value = "";
            }
        }
        else {
            if (_value == 0) {
                field.value = "";
            }
        }
    };
    CalculatorForm.prototype.outFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        if (!field.classList.contains('js-copy-field')) {
            var value = field.getAttribute('data-value');
            // field.value = value;
            if (field.value == '') {
                field.value = value;
            }
        }
        if (field.value == '') {
            field.value = 0;
        }
    };
    CalculatorForm.prototype.keyInput = function (event) {
        event.preventDefault();
        this.formValid = true;
        var field = event.target;
        var value = field.value;
        var newValue = value.replace(/ /g, '');
        if (!field.classList.contains('js-copy-field')) {
            field.setAttribute('data-value', newValue);
            field.setAttribute('placeholder', newValue);
        }
        this.formValid = this.validationService.validateCalculator(event, this.calculatorSubmit);
    };
    CalculatorForm.prototype.checkBaloonPayments = function (event) {
        var value = event.currentTarget.value;
        var balloonInput = Array.from(this.element.querySelectorAll(".js-balloon"));
        // if (balloonInput.length > 0) {
        // 	if (value == '84') {
        // 		balloonInput.forEach(element => {
        // 			element.value = "0";
        // 			element.placeholder = "0";
        // 			element.max = "0";
        // 			element.min = "0";
        // 			element.setAttribute("data-value", "0");
        // 		});
        // 	} else {
        // 		balloonInput.forEach(element => {
        // 			element.value = "0";
        // 			element.placeholder = "0";
        // 			element.max = "40";
        // 			element.min = "0";
        // 			element.setAttribute("data-value", "0");
        // 		});
        // 	}
        // }
    };
    return CalculatorForm;
}(Base));
export { CalculatorForm };



//////////////////
// WEBPACK FOOTER
// ./components/calculator-form/calculator-form.component.ts
// module id = 159
// module chunks = 0